module.exports = __webpack_public_path__ + "img/search-icon.6988f3d7.svg";